import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * Linhas de economia, Pix e parcelamento abaixo do preço.
 * Acompanha a troca de variante como o product-price: pega o próprio bloco no HTML novo da seção.
 */
class BravoPreco extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.closest('.shopify-section, dialog')?.addEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.closest('.shopify-section, dialog')?.removeEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  #onProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    event.promise
      .then(({ detail }) => {
        const novo = detail?.html?.querySelector(`bravo-preco[data-block-id="${this.dataset.blockId}"]`);
        if (novo) this.innerHTML = novo.innerHTML;
      })
      .catch(() => {});
  };
}

if (!customElements.get('bravo-preco')) customElements.define('bravo-preco', BravoPreco);
